import { render, staticRenderFns } from "./MenuResponsive.vue?vue&type=template&id=12a70158&scoped=true"
import script from "./MenuResponsive.vue?vue&type=script&lang=js"
export * from "./MenuResponsive.vue?vue&type=script&lang=js"
import style0 from "./MenuResponsive.vue?vue&type=style&index=0&id=12a70158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a70158",
  null
  
)

/* custom blocks */
import block0 from "./MenuResponsive.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports